import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-764759f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container-all"
};
const _hoisted_2 = {
  class: "info-content"
};
const _hoisted_3 = {
  key: 0,
  class: "loading-spinner"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备编号：", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "气瓶压力：", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电池电压：", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "信号强度：", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "腔内温度：", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "腔内湿度：", -1));
import { BaiduMap, BmMarker, BmInfoWindow, BmPolyline } from 'vue-baidu-map-3x';
import { ref, nextTick } from 'vue';
import { useRouter } from "vue-router";
import { weChatrequest } from '@/utils/request';
import { runtimeById } from "@/api/deviceManage";
import axios from 'axios';
export default {
  __name: 'container-baidu',
  setup(__props) {
    const router = useRouter();
    const mizhiBoundary = ref([]);
    const mizhiBoundary1 = ref([]);
    const bigRect = [{
      lng: 70,
      lat: 10
    }, {
      lng: 140,
      lat: 10
    }, {
      lng: 140,
      lat: 60
    }, {
      lng: 70,
      lat: 60
    }];
    const maskPath = ref([]);
    // GCJ-02转BD-09
    const gcj2bd = (lng, lat) => {
      const x = lng,
        y = lat;
      const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * Math.PI);
      const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * Math.PI);
      return {
        lng: +(z * Math.cos(theta) + 0.0065).toFixed(6),
        lat: +(z * Math.sin(theta) + 0.006).toFixed(6)
      };
    };
    axios.get('https://restapi.amap.com/v3/config/district?keywords=米脂县&subdistrict=0&extensions=all&key=9d0af08238aa06bd5255c5c977198b9c').then(res => {
      const data = res.data;
      const polylineStr = data.districts[0].polyline.split('|')[0]; // 第1个多边形
      const points = polylineStr.split(';').map(pt => pt.split(',').map(Number));
      const baiduPoints = points.map(([lng, lat]) => gcj2bd(lng, lat));
      const polylineStr1 = data.districts[0].polyline.split('|')[1]; // 第2个多边形
      const points1 = polylineStr1.split(';').map(pt => pt.split(',').map(Number));
      const baiduPoints1 = points1.map(([lng, lat]) => gcj2bd(lng, lat));
      mizhiBoundary.value = baiduPoints;
      mizhiBoundary1.value = baiduPoints1;
      // maskPath.value = [...bigRect, ...mizhiBoundary1.value.slice().reverse()]
    });
    const mapStyle = ref({
      styleJson: [{
        "featureType": "land",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#021a35"
        }
      }, {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#113549ff"
        }
      }, {
        "featureType": "green",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#0e1b30ff"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry.topfill",
        "stylers": {
          "color": "#113549ff"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry.sidefill",
        "stylers": {
          "color": "#143e56ff"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#dadada00"
        }
      }, {
        "featureType": "subwaystation",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#113549B2"
        }
      }, {
        "featureType": "education",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#12223dff"
        }
      }, {
        "featureType": "medical",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#12223dff"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "color": "#12223dff"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "weight": 4
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#fed66900"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "weight": 2
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffeebb00"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "local",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "local",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "local",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "local",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#979c9aff"
        }
      }, {
        "featureType": "local",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "railway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "subway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "weight": 1
        }
      }, {
        "featureType": "subway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#d8d8d8ff"
        }
      }, {
        "featureType": "subway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "subway",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "subway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#979c9aff"
        }
      }, {
        "featureType": "subway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "city",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "city",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "city",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "city",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "town",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "town",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "town",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#454d50ff"
        }
      }, {
        "featureType": "town",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "districtlabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "district",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "manmade",
        "elementType": "geometry",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "districtlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffffff"
        }
      }, {
        "featureType": "entertainment",
        "elementType": "geometry",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "shopping",
        "elementType": "geometry",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "6"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "7"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "8"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "9"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "10"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "6"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "7"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "8"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "9"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,10",
          "level": "10"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "subwaylabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "subwaylabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "tertiarywaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "tertiarywaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "provincialwaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "provincialwaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "nationalwaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "nationalwaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "highwaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "highwaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "village",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "district",
        "elementType": "labels.text",
        "stylers": {
          "fontsize": 20
        }
      }, {
        "featureType": "district",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "district",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "country",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "country",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff10"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.text",
        "stylers": {
          "fontsize": 20
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels.text",
        "stylers": {
          "fontsize": 20
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels.text",
        "stylers": {
          "fontsize": 20
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels.text",
        "stylers": {
          "fontsize": 20
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "estate",
        "elementType": "geometry",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "scenicspotsway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "scenicspotsway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "universityway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "universityway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "vacationway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "vacationway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#12223dff"
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "educationlabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "educationlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "educationlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "educationlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "transportation",
        "elementType": "geometry",
        "stylers": {
          "color": "#113549ff"
        }
      }, {
        "featureType": "airportlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "airportlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "medicallabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "medicallabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "medicallabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "airportlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "entertainmentlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "entertainmentlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "entertainmentlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "estatelabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "estatelabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "estatelabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "businesstowerlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "businesstowerlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "businesstowerlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "companylabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "companylabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "companylabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "governmentlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "governmentlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "governmentlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "restaurantlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "restaurantlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "restaurantlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "hotellabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "hotellabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "hotellabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "shoppinglabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "shoppinglabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "shoppinglabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "lifeservicelabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "lifeservicelabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "lifeservicelabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "carservicelabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "carservicelabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "carservicelabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "financelabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "financelabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "financelabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "otherlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "otherlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "otherlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "manmade",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "manmade",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "transportation",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "transportation",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "education",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "education",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "medical",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "medical",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2dc4bbff"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#ffffff00"
        }
      }]
    });
    const infoWindow = ref({
      show: false,
      actNum: "",
      bottlePressure: null,
      batLevel: null,
      signalStrength: null,
      temp: null,
      humidity: null,
      position: {
        lng: 0,
        lat: 0
      },
      loading: true,
      id: null
    });
    // const trackPath = ref([
    //   { lng: 116.404, lat: 39.915 },
    //   { lng: 116.405, lat: 39.920 },
    //   { lng: 108.96124705710682, lat: 34.34323242501682 },
    //   { lng: 114.11019051141885, lat: 32.24014790656942}
    // ]);

    //设备单击展示数据 
    const goDetail = marker => {
      if (infoWindow.value.id === marker.id) {
        infoWindow.value.show = false;
        nextTick(() => {
          infoWindow.value.show = true;
        });
      } else {
        getData(marker);
      }
    };
    const getData = marker => {
      runtimeById(marker.id).then(res => {
        if (res.code == 0 && res.data) {
          const data = res.data;
          nextTick(() => {
            infoWindow.value = {
              show: true,
              id: marker.id,
              actNum: marker.actNum,
              position: {
                lng: marker.longitude,
                lat: marker.latitude
              },
              bottlePressure: data.bottlePressure,
              batLevel: data.batLevel,
              signalStrength: data.signalStrength,
              temp: data.temp,
              humidity: data.humidity,
              loading: false
            };
          });
        } else {
          ElMessage.closeAll();
          ElMessage.warning("该设备暂无运行数据,可双击进入设备详情查看详细数据！");
        }
      });
    };
    //设备双击跳转 
    const handleDblclick = marker => {
      router.push(`/deviceRunData?actId=${marker.id}&rowData=${JSON.stringify(marker)}`);
    };
    const markers = ref([]);
    const loading = ref(false);
    loading.value = false;
    const getMarkers = () => {
      weChatrequest({
        url: "/api/v1/actuator/actMapList",
        method: "get"
      }).then(res => {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            // 离线和告警的闪烁
            if (res.data[i].actStatus != 1) {
              res.data[i].animationType = "BMAP_ANIMATION_BOUNCE";
            }
          }
          markers.value = res.data || [];
        }
        loading.value = false;
      });
    };
    getMarkers();
    return (_ctx, _cache) => {
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(BaiduMap), {
        "map-type": "BMAP_NORMAL_MAP",
        class: "map",
        center: {
          lng: 110.1781,
          lat: 37.7492
        },
        zoom: 12,
        "max-zoom": 18,
        "scroll-wheel-zoom": true,
        "double-click-zoom": false,
        ak: "B8MhW4LFUaqR5DlevDkDVKDtGjSeKz7B"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markers.value, marker => {
          return _openBlock(), _createBlock(_unref(BmMarker), {
            key: marker.id,
            position: {
              lng: marker.longitude,
              lat: marker.latitude
            },
            animation: marker.animationType,
            icon: {
              url: marker.actStatus == 1 ? require('@/assets/img/device1.png') : marker.actStatus == 2 ? require('@/assets/img/device.png') : require('@/assets/img/device2.png'),
              size: {
                width: 50,
                height: 75
              }
            },
            onClick: $event => goDetail(marker),
            onDblclick: $event => handleDblclick(marker)
          }, null, 8, ["position", "animation", "icon", "onClick", "onDblclick"]);
        }), 128)), _createVNode(_unref(BmInfoWindow), {
          position: infoWindow.value.position,
          show: infoWindow.value.show,
          class: "custom-info-window",
          width: 0,
          height: 130,
          "max-width": 100,
          onClose: _cache[0] || (_cache[0] = $event => infoWindow.value.show = false),
          onOpen: _cache[1] || (_cache[1] = $event => infoWindow.value.show = true)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [infoWindow.value.loading ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("p", null, [_hoisted_5, _createTextVNode(_toDisplayString(infoWindow.value.actNum), 1)]), _createElementVNode("p", null, [_hoisted_6, _createTextVNode(_toDisplayString(infoWindow.value.bottlePressure == null ? '-' : infoWindow.value.bottlePressure) + " mPa", 1)]), _createElementVNode("p", null, [_hoisted_7, _createTextVNode(_toDisplayString(infoWindow.value.batLevel == null ? '-' : infoWindow.value.batLevel) + " %", 1)]), _createElementVNode("p", null, [_hoisted_8, _createTextVNode(_toDisplayString(infoWindow.value.signalStrength == null ? '-' : infoWindow.value.signalStrength) + " %", 1)]), _createElementVNode("p", null, [_hoisted_9, _createTextVNode(_toDisplayString(infoWindow.value.temp == null ? '-' : infoWindow.value.temp) + " ℃", 1)]), _createElementVNode("p", null, [_hoisted_10, _createTextVNode(_toDisplayString(infoWindow.value.humidity == null ? '-' : infoWindow.value.humidity) + " %RH", 1)])]))])]),
          _: 1
        }, 8, ["position", "show"])]),
        _: 1
      }, 8, ["center"])])), [[_directive_loading, loading.value]]);
    };
  }
};